var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M256 0c70.68 0 134.69 28.66 181.01 74.99C483.34 121.31 512 185.32 512 256c0 70.68-28.66 134.69-74.99 181.01C390.69 483.34 326.68 512 256 512c-70.68 0-134.69-28.66-181.01-74.99C28.66 390.69 0 326.68 0 256c0-70.68 28.66-134.69 74.99-181.01C121.31 28.66 185.32 0 256 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 19.48c65.3 0 124.46 26.48 167.25 69.27l1.09 1.18c42.14 42.71 68.18 101.37 68.18 166.06 0 65.31-26.5 124.46-69.29 167.25l-1.18 1.09c-42.73 42.16-101.4 68.19-166.05 68.19-65.23 0-124.37-26.51-167.18-69.33-42.84-42.74-69.33-101.89-69.33-167.2 0-65.31 26.48-124.45 69.27-167.24C131.55 45.96 190.7 19.48 256 19.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF2B2D",
    d: "M256 39.59c119.52 0 216.41 96.89 216.41 216.4 0 119.52-96.89 216.42-216.41 216.42-119.51 0-216.4-96.9-216.4-216.42 0-119.51 96.89-216.4 216.4-216.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.6 194.09h111.26v-132c28.97-14.39 61.6-22.5 96.14-22.5 5.78 0 11.5.24 17.15.68v153.82h190.26c5.85 19.6 9 40.4 9 61.9 0 17.71-2.14 34.91-6.16 51.39h-193.1v164.35c-5.65.45-11.37.68-17.15.68-34.54 0-67.17-8.11-96.14-22.5V307.38H45.76a216.555 216.555 0 0 1-6.16-51.39c0-21.5 3.15-42.3 9-61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002868",
    d: "M244.82 39.88V222.4h224.99c1.71 10.95 2.6 22.18 2.6 33.59 0 7.79-.43 15.49-1.24 23.06H244.82v193.08c-19.68-1-38.69-4.64-56.64-10.57V279.05H40.84c-.81-7.57-1.24-15.27-1.24-23.06 0-11.41.89-22.64 2.6-33.59h145.98V50.44c17.95-5.92 36.96-9.57 56.64-10.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.7ce5093ab8273d4fc1878f5f6f86ad10.svg";
export { ForwardRef as ReactComponent };